import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);
import Full from '@/containers/Full'
import Full2 from '@/containers/Full2'
import Full3 from '@/containers/Full3'


// Views - Pages
import Page404 from '@/views/errorPages/Page404'
import Page500 from '@/views/errorPages/Page500'


/* login */
const Login = _import('login/index');
Vue.use(Router);

export const constantRouterMap = [
    {path: '/login', component: Login, hidden: true},
    {
        path: '/pages', redirect: '/pages/p404', name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
            // Full,
        },
        children: [{path: '404', name: 'Page404', component: _import('errorPages/Page404')},
            {path: '500', name: 'Page500', component: _import('errorPages/Page404')},
        ]
    },
    {
        path: '/home',
        name: 'HOME1',
        component: Full2,
        hidden: false,
        children: [
            {path: '/home', name: 'HOME', icon: 'speedometer', component: _import('home/index')},
        ]
    },
    {
        path: '/wechat',
        name: 'WECHAT2',
        component: Full3,
        hidden: false,
        children: [
            {path: '/wechat', name: 'WECHAT', icon: 'speedometer', component: _import('wechat/index')},
        ]
    },
]

export const asyncRouterMap = [
    {
        path: '/',
        redirect: '/dashboard',
        name: '首页',
        component: Full,
        hidden: false,
        children: [
            {path: '/dashboard',name: '首页',icon: "icon ivu-icon-home1 ivu-icon-adt",component: _import('Home'),
            // {path: '/dashboard',name: '首页',icon: "icon ivu-icon-home1 ivu-icon-adt",component: _import('other/Html'),
            },
            {path: '/company',name: '工商信息',icon: "icon ivu-icon-company ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/company/search',name: '工商信息',component: _import('Company'), hidden:false},
                    {path: 'adt/company/relationSelect',name: '关系查询',component: _import('company/relation')},
                    {path: 'adt/company/companychange',name: '工商变更',component: _import('company/alteration')},
                    {path: 'adt/company/companyshareholder',name: '股东结构',component: _import('company/shareholder')},
                    {path: 'adt/company/companykeyperson',name: '主要人员',component: _import('company/personnel')},
                    {path: 'adt/company/companyinvestment',name: '对外投资',component: _import('company/investment')},
                    {path: 'adt/company/companybranch',name: '分支机构',component: _import('company/branch')},
                    {path: 'adt/company/equity',name: '股权出质',component: _import('company/stock')},
                    {path: 'adt/company/companymortgage',name: '动产抵押',component: _import('company/mortgage')},
                    {path: 'adt/company/companyjudriskassist',name: '司法协助',component: _import('company/judicial')},
                    {path: 'adt/company/companyliquidation',name: '清算',component: _import('company/liquidation')},
                    {path: 'adt/company/companycancelinfo',name: '注销',component: _import('company/logout')},
                ]
            },
            {path: '/car',name: '汽车',icon: "icon ivu-icon-car ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/searchvehicle',name: '汽车',component: _import('car/car'), hidden:false},
                    {path: 'qitongcha/enweb/searchdistributor',name: '经销商',component: _import('car/agency'), hidden:false},
                ]
            },
            {path: '/macroeconomy',name: '产业经济',icon: "icon ivu-icon-macroeconomy ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/macroeconomy/search',name: '产业经济',component: _import('Macroeconnmy'), hidden:false},
                ]
            },
            {path: '/chinaeconomy',name: '国家经济',icon: "icon ivu-icon-ecochina ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/countrymacromonth/search',name: '全国宏观月度库',component: _import('chinaeconomy/CountryMacroMonth'), hidden:false},
                    {path: 'adt/countrymacroyear/search',name: '全国宏观年度库',component: _import('chinaeconomy/CountryMacroYear'), hidden:false},
                    {path: 'adt/provincemacromonth/search',name: '分省宏观月度库',component: _import('chinaeconomy/ProvinceMacroMonth'), hidden:false},
                    {path: 'adt/provincemacroyear/search',name: '分省宏观年度库',component: _import('chinaeconomy/ProvinceMacroYear'), hidden:false},
                    {path: 'adt/customsmonth/search',name: '海关月度库',component: _import('chinaeconomy/CustomsMonth'), hidden:false},
                    {path: 'adt/cityyear/search',name: '城市年度库',component: _import('chinaeconomy/CityYear'), hidden:false},
                    {path: 'adt/countyyear/search',name: '县域年度库',component: _import('chinaeconomy/CountyYear'), hidden:false},
                    {path: 'adt/oecdmonth/search',name: 'OECD月度库',component: _import('chinaeconomy/OECDMonth'), hidden:false},
                    {path: 'adt/oecdyear/search',name: 'OECD年度库',component: _import('chinaeconomy/OECDYear'), hidden:false},
                ]
            },
            {path: '/yearbook',name: '年鉴',icon: "icon ivu-icon-yearbook ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/provinciallevel/search',name: '省级',component: _import('ecoyearbook/ProvincialLevel'), hidden:false},
                    {path: 'adt/jjjcitygroup/search',name: '京津冀城市群',component: _import('ecoyearbook/JJJCityGroup'), hidden:false},
                    {path: 'adt/ygabayarea/search',name: '港粤澳大湾区',component: _import('ecoyearbook/YGABayArea'), hidden:false},
                    {path: 'adt/northbaycitygroup/search',name: '北部湾城市群',component: _import('ecoyearbook/NorthBayCityGroup'), hidden:false},
                    {path: 'adt/cycitygroup/search',name: '成渝城市群',component: _import('ecoyearbook/CYCityGroup'), hidden:false},
                ]
            },
            {path: '/onebeltoneroad',name: '一带一路',icon: "icon ivu-icon-onebeltoneroad ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/newasiaeuropebridge/search',name: '新亚欧大陆桥',component: _import('onebeltoneroad/NewAsiaEuropeBridge'), hidden:false},
                    {path: 'adt/chinacentralwestasia/search',name: '中国-中亚-西亚',component: _import('onebeltoneroad/ChinaCentralWestAsia'), hidden:false},
                    {path: 'adt/chinaba/search',name: '中巴',component: _import('onebeltoneroad/ChinaBa'), hidden:false},
                    {path: 'adt/chinamr/search',name: '中蒙俄',component: _import('onebeltoneroad/ChinaMR'), hidden:false},
                    {path: 'adt/chinaisland/search',name: '中国-中南半岛',component: _import('onebeltoneroad/ChinaIsland'), hidden:false},
                    {path: 'adt/mzym/search',name: '孟中印缅',component: _import('onebeltoneroad/MZYM'), hidden:false},
                    {path: 'adt/seasilkroad/search',name: '21世纪海上丝绸之路',component: _import('onebeltoneroad/SeaSilkRoad'), hidden:false},
                ]
            },
            {path: '/ecoworld',name: '世界经济',icon: "icon ivu-icon-ecoworld ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/asiaafrica/search',name: '亚非',component: _import('ecoworld/AsiaAfrica'), hidden:false},
                    {path: 'adt/europe/search',name: '欧洲',component: _import('ecoworld/Europe'), hidden:false},
                    {path: 'adt/america/search',name: '美洲',component: _import('ecoworld/America'), hidden:false},
                    {path: 'adt/internation/search',name: '国际比较',component: _import('ecoworld/Internation'), hidden:false},
                ]
            },
            {path: '/monitorandcontrol',name: '我的监控',icon: "icon ivu-icon-monitor ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/monitorandcontrol/search',name: '我的监控',component: _import('Monitorandcontrol'), hidden:false},
                ]
            },
            {path: '/skyminder',name: '全球查',icon: "icon ivu-icon-skyminder ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/skyminder/skyminder',name: '全球查',component: _import('other/Html'), hidden:false},
                ]
            },
            {path: '/investment',name: '投融资',icon: "icon ivu-icon-investment ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/invest/investProject',name: '融资项目',component: _import('invest/investProject'), hidden:false},
                    {path: 'qitongcha/enweb/investPro',name: '项目融资情况',component: _import('invest/investPro')},
                    {path: 'adt/invest/projectnews',name: '投资新闻',component: _import('invest/projectnews')},
                    {path: 'adt/invest/investOrg',name: '投资机构',component: _import('invest/organization')},
                    {path: 'adt/invest/investor',name: '投资人',component: _import('investment/investor')},
                    {path: 'qitongcha/enweb/investper',name: '投资偏好',component: _import('investment/preference')},
                    {path: 'investOrgCount',name: '投资机构统计',component: _import('investment/projectByArea')},
                    // {path: 'investOrgCount',name: '投资机构统计',component: {render (c) { return c('router-view') }},
                    //     children:[
                    //         {path: 'adt/invest/projectByArea',name: '按地域统计',component: _import('investment/projectByArea'),hidden:false},
                    //         {path: 'adt/invest/projectByYear',name: '按年度统计',component: _import('investment/projectByYear')},
                    //         {path: 'adt/invest/projectByPhase',name: '按融资轮次统计',component: _import('investment/projectByPhase')}
                    //     ]
                    // },
                    {path: 'investProjectCount',name: '融资项目统计',component: _import('investment/orgByArea')},
                    // {path: 'investProjectCount',name: '融资项目统计',component: {render (c) { return c('router-view') }},
                    //     children:[
                    //         {path: 'adt/invest/orgByArea',name: '按地域统计',component: _import('other/Html'),hidden:false},
                    //         {path: 'adt/invest/orgByYear',name: '按年度统计',component: _import('other/Html')},
                    //         {path: 'adt/invest/orgByPhase',name: '按融资轮次统计',component: _import('other/Html')}
                    //     ]
                    // },
                ]
            },
            {path: '/credit',name: '企业信用',icon: "icon ivu-icon-credit ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/adlic',name: '行政许可',component: _import('credit/administrative'), hidden:false},
                    {path: 'qitongcha/enweb/credit/adlicicb',name: '行政许可(工商局)',component: _import('credit/administrativeAaum')},
                    {path: 'qitongcha/enweb/adpenlty',name: '行政处罚(信用中国)',component: _import('credit/penalize')},
                    {path: 'qitongcha/enweb/adpenltyIcb',name: '行政处罚(工商局)',component: _import('credit/penalizeAaum')},
                    {path: 'qitongcha/enweb/good',name: '税务评级',component: _import('credit/grade')},
                    {path: 'qitongcha/enweb/badtax',name: '税务处罚',component: _import('credit/punish')},
                    {path: 'qitongcha/enweb/badabn',name: '经营异常',component: _import('credit/abnormal')},
                    {path: 'qitongcha/enweb/badabnicb',name: '经营异常(工商局)',component: _import('credit/abnormalAaum')},
                    {path: 'qitongcha/enweb/focu',name: '产品抽查',component: _import('credit/examination')},
                    {path: 'qitongcha/enweb/focuicb',name: '产品抽查(工商局)',component: _import('credit/examinationAaum')},
                    {path: 'qitongcha/enweb/badrec',name: '采购不良行为',component: _import('credit/misconduct')},
                    {path: 'qitongcha/enweb/envPunish',name: '环保处罚',component: _import('credit/environmental')},
                    {path: 'qitongcha/enweb/ownTax',name: '欠税公告',component: _import('credit/outstanding')},
                    {path: 'creditpevc',name: '金融领域严重失信PEVC企业',component: _import('credit/CreditPEVC')},
                    {path: 'creditobligor',name: '金融领域严重失信债务人',component: _import('credit/CreditObligor')},
                    {path: 'creditescape',name: '金融领域恶意逃废债借款人',component: _import('credit/CreditEscape')},
                    {path: 'creditcollect',name: '金融领域非法集资企业',component: _import('credit/CreditCollect')},
                    {path: 'creditother',name: '金融领域其他严重违法企业',component: _import('credit/CreditOther')},
                    {path: 'creditenvpro',name: '环保重点监控企业',component: _import('credit/CreditEnvProtection')},
                    {path: 'creditgov',name: '国有企业拖欠民营账款失信案例',component: _import('credit/CreditGov')},
                    {path: 'qitongcha/enweb/limithigh',name: '限制高消费',component: _import('credit/limithigh')},
                    {path: 'qitongcha/enweb/aqsc',name: '安全生产失信',component: _import('credit/security')},
                    {path: 'qitongcha/enweb/salary',name: '拖欠工资失信',component: _import('credit/unpaidWages')},
                    {path: 'qitongcha/enweb/electricmanager',name: '电力领域失信监管',component: _import('credit/electricity')},
                    {path: 'qitongcha/enweb/electricrelevancy',name: '电力领域失信关联企业',component: _import('credit/electricityCompany')},
                    {path: 'qitongcha/enweb/yzsx',name: '统计领域严重失信',component: _import('credit/statistics')},
                    {path: 'qitongcha/enweb/zdsswfaj',name: '重大税收违法案件当事人',component: _import('credit/revenue')},
                    {path: 'qitongcha/enweb/charity',name: '慈善捐助领域联合惩戒对象',component: _import('credit/charity')},
                ]
            },
            {path: '/enqaqc',name: '企业资质',icon: "icon ivu-icon-enqaqc ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/enqaqc',name: '资质许可',component: _import('certification/certification'), hidden:false},
                    // {path: 'qitongcha/enweb/enqaspecial',name: '特殊许可',component: _import('other/Html')},
                    // {path: 'qitongcha/enweb/enqaproduct',name: '产品许可',component: _import('other/Html')},
                    // {path: 'qitongcha/enweb/enqaperson',name: '人员资质',component: _import('other/Html')},
                ]
            },
            {path: '/judrisk',name: '司法文书',icon: "icon ivu-icon-judrisk ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/lawsuit',name: '法律诉讼',component: _import('judicial1/legislation'), hidden:false},
                    {path: 'qitongcha/enweb/session',name: '开庭公告',component: _import('judicial1/session')},
                    {path: 'qitongcha/enweb/count',name: '法院公告',component: _import('judicial1/count')},
                    {path: 'qitongcha/enweb/bank',name: '破产',component: _import('judicial1/bankrupt') },
                    {path: 'qitongcha/enweb/badexe',name: '失信被执行人',component: _import('judicial1/enforcement')},
                ]
            },
            {path: '/ipr',name: '知识产权',icon: "icon ivu-icon-ipr ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/trademark',name: '商标',component: _import('intellectualProperty/trademark'), hidden:false},
                    {path: 'qitongcha/enweb/patent',name: '专利',component: _import('intellectualProperty/patent')},
                    {path: 'qitongcha/enweb/softwarecopyright',name: '软件著作权',component: _import('intellectualProperty/production')},
                    {path: 'qitongcha/enweb/workscopyright',name: '作品著作权',component: _import('intellectualProperty/software')},
                    {path: 'qitongcha/enweb/webiste',name: '网站备案',component: _import('intellectualProperty/webiste')},
                    {path: 'qitongcha/enweb/book',name: '图书',component: _import('intellectualProperty/books')},
                    {path: 'qitongcha/enweb/wechat',name: '微信公众号',component: _import('intellectualProperty/wechat')},
                    {path: 'qitongcha/enweb/app',name: '应用APP',component: _import('intellectualProperty/apply')},
                ]
            },
            {path: '/probid',name: '招标中标',icon: "icon ivu-icon-probid ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/allProject',name: '全部项目',component: _import('probid/allProject'), hidden:false},
                    {path: 'qitongcha/enweb/provinceProject',name: '省部项目',component: _import('probid/provinceProbid')},
                    {path: 'qitongcha/enweb/cityProject',name: '地市项目',component: _import('probid/cityProbid')},
                    {path: 'qitongcha/enweb/placeProject',name: '区县项目',component: _import('probid/placeProject')},
                    {path: 'qitongcha/enweb/nameProject',name: '项目名称',component: _import('probid/nameProject')},
                    {path: 'qitongcha/enweb/companyProject',name: '业主单位',component: _import('probid/companyProject')},
                    {path: 'qitongcha/enweb/mainProject',name: '项目设备',component: _import('probid/mainProject')},
                    {path: 'qitongcha/enweb/detailProject',name: '项目概况',component: _import('probid/detailProject')},
                    {path: 'qitongcha/enweb/govbid',name: '政府招标',component: _import('probid/governmentTender')},
                    {path: 'qitongcha/enweb/govwinbid',name: '政府中标',component: _import('probid/governmentOutbid')},
                    {path: 'qitongcha/enweb/enbid',name: '央企招标',component: _import('probid/centralComTender')},
                    {path: 'qitongcha/enweb/enwinbid',name: '央企中标',component: _import('probid/centralComOutbid')},
                ]
            },
            {path: '/standard',name: '标准',icon: "icon ivu-icon-standard ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [

                    {path: 'qitongcha/enweb/gStandard',name: '国家标准',component: _import('standard/coutryStandard'), hidden:false},
                    {path: 'qitongcha/enweb/hStandard',name: '行业标准',component: _import('standard/industryStandard')},
                    {path: 'qitongcha/enweb/dStandard',name: '地方标准',component: _import('standard/dStandard')},
                    {path: 'qitongcha/enweb/tStandard',name: '团体标准',component: _import('standard/tStandard')}

                ]
            },
            {path: '/bond',name: '基金债券',icon: "icon ivu-icon-bond ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/company/bondbasic',name: '债券',component: _import('bond/bondbasic'), hidden:false},
                    {path: 'adt/company/fundbasic',name: '基金',component: _import('bond/fundbasic')},
                ]
            },
            {path: '/policy',name: '政策法规',icon: "icon ivu-icon-policy ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/policy/policy',name: '政策法规',component: _import('other/Html'), hidden:false},
                ]
            },
            {path: '/reward',name: '成果奖励',icon: "icon ivu-icon-reward ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/countryReward',name: '国家奖励',component: _import('reward/countryReward'), hidden:false},
                    {path: 'qitongcha/enweb/provinceReward',name: '省部奖励',component: _import('reward/provinceReward')},
                    {path: 'qitongcha/enweb/societyReward',name: '社会奖励',component: _import('reward/societyReward')}
                ]
            },
            {path: '/tech',name: '科技成果',icon: "icon ivu-icon-reward ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/techReward',name: '科技成果',component: _import('reward/techReward')}
                ]
            },
            {path: '/product',name: '产品价格信息',icon: "icon ivu-icon-product ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/futureGoods',name: '期货价格',component: _import('product/futureGoods'), hidden:false},
                    {path: 'qitongcha/enweb/spotGoods',name: '现货价格',component: _import('product/spotGoods')}
                ]
            },
            {path: '/land',name: '土地信息',icon: "icon ivu-icon-land ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/biglandSales',name: '大地块出让',component: _import('land/biglandSales'), hidden:false},
                    {path: 'qitongcha/enweb/givingNotice',name: '出让公告',component: _import('land/givingNotice')},
                    {path: 'qitongcha/enweb/landMortgage',name: '土地抵押',component: _import('land/landMortgage')},
                    {path: 'qitongcha/enweb/landPlan',name: '供地计划',component: _import('land/landPlan')},
                    {path: 'qitongcha/enweb/landPublic',name: '地块公示',component: _import('land/landPublic')},
                    {path: 'qitongcha/enweb/landPurchase',name: '大企业购地',component: _import('land/landPurchase')},
                    {path: 'qitongcha/enweb/landRent',name: '土地出租',component: _import('land/landRent')},
                    {path: 'qitongcha/enweb/landResult',name: '土地结果',component: _import('land/landResult')},
                    {path: 'qitongcha/enweb/landTransfer',name: '土地转让',component: _import('land/landTransfer')},
                ]
            },
            {path: '/talent',name: '人才信息',icon: "icon ivu-icon-talent ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/talent',name: '人才信息',component: _import('talent/talent'), hidden:false},
                ]
            },
            {path: '/recruit',name: '招聘信息',icon: "icon ivu-icon-recruit ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/recruit/recruit',name: '招聘信息',component: _import('recruit/recruit'), hidden:false},
                ]
            },
            {path: '/fund',name: '国家基金',icon: "icon ivu-icon-fund ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/naturalAchievement',name: '国家自然基金',component: _import('fund/naturalAchievement')},
                    {path: 'qitongcha/enweb/natural',name: '国家自然基金成果',component: _import('fund/natural'), hidden:false},
                    {path: 'qitongcha/enweb/social',name: '国家社科基金',component: _import('fund/social')},

                ]
            },
            {path: '/list',name: '上市信息',icon: "icon ivu-icon-list ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/csrc',name: '上市公司信息',component: _import('list/csrc'), hidden:false},
                    {path: 'qitongcha/csrc/mortgage',name: '抵押信息',component: _import('list/mortgage')},
                    {path: 'qitongcha/csrc/guaranty',name: '对外担保信息',component: _import('list/guaranty')},
                    {path: 'qitongcha/csrc/arbitration',name: '诉讼仲裁信息',component: _import('list/arbitration')},
                    {path: 'qitongcha/enweb/indicators',name: '财务摘要',component: _import('list/indicators')},
                    {path: 'qitongcha/enweb/csrcreport',name: '财务报表',component: _import('list/csrcreport')},
                    {path: 'qitongcha/enweb/shareholdmain',name: '主要股东',component: _import('list/shareholdmain')},
                    {path: 'qitongcha/enweb/shareten',name: '流通股东',component: _import('list/shareten')},
                    {path: 'qitongcha/enweb/mainten',name: '十大股东',component: _import('list/mainten')},
                    {path: 'qitongcha/enweb/executive',name: '公司高管',component: _import('list/executive')},
                    {path: 'qitongcha/enweb/csrcallot',name: '分红配股',component: _import('list/csrcallot')},
                    {path: 'qitongcha/enweb/csrcari',name: '发行增发',component: _import('list/csrcari')},
                    {path: 'qitongcha/enweb/csrcbonus',name: '分红配送',component: _import('list/csrcbonus')},
                    {path: 'qitongcha/enweb/csrcrltb',name: '限售解禁',component: _import('list/csrcrltb')},
                    {path: 'qitongcha/enweb/csrctni',name: '新股发行',component: _import('list/csrctni')},
                    {path: 'qitongcha/enweb/csrctrt',name: '募资投向',component: _import('list/csrctrt')},
                    {path: 'qitongcha/enweb/csrcplan',name: '发行计划',component: _import('list/csrcplan')},
                    {path: 'qitongcha/enweb/csrcresult',name: '发行结果',component: _import('list/csrcresult')},
                    {path: 'qitongcha/enweb/companyreport',name: '上市公告',component: _import('list/companyreport')},
                ]
            },
            {path: '/park',name: '产业园区',icon: "icon ivu-icon-park ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'park',name: '产业园区',component: _import('Park'), hidden:false},

                ]
            },
            {path: '/research',name: '行业研报',icon: "icon ivu-icon-research ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'research', name: '行业研报',component: _import('research/ResearchReport')}

                ]
            },
            {path: '/import',name: '匹配查询',icon: "icon ivu-icon-import ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/importexcel/importindex',name: '匹配查询',component: _import('other/Html'), hidden:false},
                ]
            },
            {path: '/webuser',name: '账号管理',icon: "icon ivu-icon-webuser ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/webuser',name: '用户管理',component: _import('webuser/webuser'), hidden:false},
                    {path: 'qitongcha/enweb/webrole',name: '角色管理',component: _import('webuser/webrole'), hidden:false},
                ]
            },
            {path: '/permission',name: '权限资源管理',icon: "icon ivu-icon-permission ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/enweb/weborgpermission',name: '组织权限',component: _import('other/Html'), hidden:false},
                    {path: 'qitongcha/enweb/weborganization',name: '组织管理',component: _import('other/Html'), hidden:false},
                ]
            },
          /*  {path: '/analysis',name: '数据分析平台',icon: "icon ivu-icon-import ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: '',name: '数据分析平台',component: _import('other/Html'), hidden:false},
                ]
            },*/
            {path: '/case',name: '案例',icon: "icon ivu-icon-case ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/case/search',name: '应用案例',component: _import('case/Case'), hidden:false},

                ]
            },
            
            {path: '/education',name: '高校信息',icon: "icon ivu-icon-school ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'school',name: '高校信息',component: _import('school/School'), hidden:false},
                    {path: 'schoolPro',name: '研究生专业',component: _import('school/SchoolPro'), hidden:false},
                    {path: 'schoolTutor',name: '研究生导师',component: _import('school/SchoolTutor'), hidden:false},
                    {path: 'workStation',name: '博士后工作站',component: _import('school/SchoolWorkStation'), hidden:false},
                    {path: 'workStationF',name: '博士后流动工作站',component: _import('school/SchoolWorkStationF'), hidden:false},
                ]
            },
            {path: '/policy',name: '政策法规',icon: "icon ivu-icon-policy ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/policy/search',name: '查政策',component: _import('policy/Policy'), hidden:false},

                ]
            },
            {path: '/amac',name: '私募基金',icon: "icon ivu-icon-amac ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'amacorg',name: '私募基金管理人信息',component: _import('amac/Amacorg')},
                    {path: 'amacqiesbp',name: '基金从业人员资格信息',component: _import('amac/Amacqiesbp')},
                    {path: 'amacpefpi',name: '私募基金管理人基金产品',component: _import('amac/Amacpefpi')},
                    {path: 'amacscamp',name: '证券公司集合资管产品',component: _import('amac/Amacscamp')},
                    {path: 'amacscdif',name: '证券公司直投基金',component: _import('amac/Amacscdif')},
                    {path: 'amacscpif',name: '证券公司私募投资基金',component: _import('amac/Amacscpif')},
                    {path: 'amacsasp',name: '资产支持专项计划',component: _import('amac/Amacsasp')},
                    {path: 'amacfcamp',name: '期货公司集合资管产品',component: _import('amac/Amacfcamp')},
                ]
            },
            
            {path: '/swap',name: '企业更新',icon: "icon ivu-icon-companyupdate ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'companyUpdateHand', name: '企业手工更新',component: _import('swap/CompanyUpdateHand')}
                ]
            },
            {path: '/apiquery',name: '接口查询',icon: "icon ivu-icon-apitimes ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'timesCount', name: '计费次数查询',component: _import('apiquery/TimesCount')}
                ]
            },
            {path: '/match',name: '匹配查询(新)',icon: "icon ivu-icon-import ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'unmatched',name: '导入记录',component: _import('match/Unmatched')},
                    {path: 'matched',name: '匹配记录',component: _import('match/Matched')}
                ]
            },
            {path: '/testcompany',name: '功能内嵌',icon: "icon ivu-icon-company ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/company/test/search',name: '工商信息',component: _import('other/Html')},
                ]
            },
            {path: '/bigdataanalyse',name: '报告下载',icon: "icon ivu-icon-bgxz ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'adt/bigdataanalyse/bigdataanalyseindex',name: '报告下载',component: _import('bigdataanalyse/bigdataanalyseindex')},
                ]
            },
            {path: '/newsinfo',name: '新闻',icon: "icon ivu-icon-newsinfo ivu-icon-adt",
                component: {render (c) { return c('router-view') }},
                children: [
                    {path: 'qitongcha/newsinfo/newsinfo',name: '新闻',component: _import('newsinfo/newsinfo'), hidden:false},
                ]
            },

        ]
    },
    {path: '/company/detail', name: '公司详情', icon: "icon ivu-icon-company",hidden:true, component: _import('CompanyDetail')},
    {path: '/case/detail', name: '案例详情', icon: "icon ivu-icon-company",hidden:true, component: _import('case/CaseDetail')},
    {path: '/warning/detail', name: '预警详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/WarningDetail')},
    {path: '/majorchange/detail', name: '动态详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/MajorchangeDetail')},
    {path: '/trade/detail', name: '商标详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/TradeDetail')},
    {path: '/fund/detail', name: '基金详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/FundDetail')},
    {path: '/bond/detail', name: '债券详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/BondDetail')},
    {path: '/annual/detail', name: '年报详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/AnnualDetail')},
    {path: '/financial/detail', name: '财务数据详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/FinancialDetail')},
    {path: '/mor/detail', name: '动产抵押详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/MorDetail')},
    {path: '/ipr/detail', name: '项目详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/IprDetail')},
    {path: '/iorg/detail', name: '机构详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/IorgDetail')},
    {path: '/govBid/detail', name: '政府招标详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/GovBidDetail')},
    {path: '/govBidList/detail', name: '政府招标详情列表', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/GovBidListDetail')},
    {path: '/govWinBid/detail', name: '政府中标详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/GovWinBidDetail')},
    {path: '/govWinBidList/detail', name: '政府中标详情列表', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/GovWinBidListDetail')},
    {path: '/enBid/detail', name: '央企招标详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/EnBidDetail')},
    {path: '/enBidList/detail', name: '央企招标详情列表', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/EnBidListDetail')},
    {path: '/enWinBid/detail', name: '央企中标详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/EnWinBidDetail')},
    {path: '/enWinBidList/detail', name: '央企中标详情列表', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/EnWinBidListDetail')},
    {path: '/managerInformation/detail', name: '基金管理人信息详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/ManagerInformationDetail')},
    {path: '/managerProducts/detail', name: '管理人基金产品详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/ManagerProductsDetail')},
    {path: '/bondCompanies/detail', name: '债券公司集合资管详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/BondCompaniesDetail')},
    {path: '/investmentFunds/detail', name: '证券公司直投基金详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/InvestmentFundsDetail')},
    {path: '/privateEquity/detail', name: '债券公司私募投资详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/PrivateEquityDetail')},
    {path: '/ventureCollectingPipe/detail', name: '期货公司集合资管详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/VentureCollectingPipeDetail')},
    {path: '/address', name: '地图', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/Address')},
    {path: '/school/detail', name: '高校详情', icon: "icon ivu-icon-company",hidden:true, component: _import('detail/SchoolDetail')},
    {path: '/park/detail', name: '园区详情', icon: "icon ivu-icon-park",hidden:true, component: _import('ParkDetail')},
    {path: '/parkMore/detail', name: '园区更多', icon: "icon ivu-icon-park",hidden:true, component: _import('ParkMore')},
    {path: '*', redirect: '/pages/404', hidden: true}

];

const createRouter = () => new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap,
});

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js